export enum LogsType {
    SYSTEM = "System",
    CBSD = "CBSD"
};